export const MeshBackground = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    <div className="mesh-blob mesh-blob-a" />
    <div className="mesh-blob mesh-blob-b" />
    <div className="mesh-blob mesh-blob-c" />
  </div>
);
